// @ts-check
import * as baseTheme from '@bottlebooks/design-tokens';
import label from '../components/Label/labelVariants';
import link from '../components/Link/linkVariants';
import p from '../components/Text/pVariants';
import text from '../components/Text/textVariants';
import title from '../components/Title/titleVariants';
import input from '../components/Input/inputVariants';

const theme = {
  ...baseTheme,
  input,
  label,
  link,
  p,
  text,
  title,
};

export default theme;
